import FI from '@/locale/fi'
import SV from '@/locale/sv'
import EN from '@/locale/en'

const browserLanguageSetting = document.documentElement.lang
let translations = EN
let curLang = "en"

if (browserLanguageSetting) curLang = browserLanguageSetting.slice(0, 2);
switch (curLang) {
    case "fi":
        translations = FI;
        break;
    case "SV":
        translations = SV;
        break;
    default:
        translations = EN;
}

export function Translate(word) {
    return translations[word];
}